// Lightweight offline persistence for EAZIKAST: caches opened days and queues
// unsynced writes in localStorage. Best-effort; all access is wrapped in try/catch.
const DAY = (pid, date) => `ez:day:${pid || "_"}:${date}`;
const QUEUE = "ez:queue";
const PROJECTS = "ez:projects";

const read = (k, fallback) => {
  try {
    const v = localStorage.getItem(k);
    return v ? JSON.parse(v) : fallback;
  } catch {
    return fallback;
  }
};
const write = (k, v) => {
  try {
    localStorage.setItem(k, JSON.stringify(v));
  } catch {
    /* quota / disabled — ignore */
  }
};

export function cacheDay(pid, date, day, base) {
  write(DAY(pid, date), { day, base: base ?? null });
}
export function readDay(pid, date) {
  return read(DAY(pid, date), null);
}
export function setBase(pid, date, base) {
  const cur = readDay(pid, date);
  if (cur) write(DAY(pid, date), { ...cur, base: base ?? null });
}

export function enqueue(pid, date) {
  const q = read(QUEUE, []);
  if (!q.some((e) => e.pid === pid && e.date === date)) {
    q.push({ pid, date });
    write(QUEUE, q);
  }
}
export function dequeue(pid, date) {
  write(QUEUE, read(QUEUE, []).filter((e) => !(e.pid === pid && e.date === date)));
}
export function readQueue() {
  return read(QUEUE, []);
}
export function queueCount() {
  return read(QUEUE, []).length;
}

export function cacheProjects(list) {
  write(PROJECTS, list || []);
}
export function readProjects() {
  return read(PROJECTS, []);
}

export const isNetworkError = (err) => !!err && !err.response;
